import React, { useState } from "react";
import icon1 from "./assets/Icon-Drip.png";
import icon2 from "./assets/Icon-Acquire.png";
import fire from "./assets/fire.png";
import { Link, NavLink } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link/dist/react-router-hash-link.cjs.production";
import useCountdown from "../../hooks/useCountDown";
import ViewModal from "../ViewModal/ViewModal";
import BidModal from "../BidModal/BidModal";
import Popup from "reactjs-popup";
const TierCard = ({ thum, gold, className, imgClassName, imgWrapClassName }) => {
  const { hours, days, minutes, seconds } = 0;
  const { timeleft } = useCountdown(2589903);

  const [openView, setOpenView] = useState(false);
  const [openBid, setOpenBid] = useState(false);
  const handleBuy = () =>{
    window.location.href="/NFTone";
  }
  return (
    <>
      <div
        className={`w-full md:w-[330px]  flex-none rounded-[20px] bg-main-black ${className}`}
      >
        <div
          className={`lg:max-h-[319px] pt-[10px] lg:pt-[20px] px-[5px] lg:px-[20px] pb-[13px] relative ${imgWrapClassName}`}
        >
          <img
            className={`w-full md:w-[290px]  mx-auto rounded-[20px] ${imgClassName}`}
            src={thum}
            alt=""
          />
          <div className="absolute w-[151px] left-1/2  bottom-[21px] -translate-x-1/2 bg-[#1D1C18] rounded-[13px] h-[36px] flex justify-center">
            <div className="flex gap-[10px] items-center">
              <img className="w-[15px] h-[20px] " src={fire} alt="" />
              <p className="text-res-xxs font-bold leading-[24px]">
                {days} : {hours} : {minutes} : {seconds}
              </p>
            </div>
          </div>
        </div>
        <div className="px-[20px] ">
          <div className=" flex justify-between ">
            <NavHashLink
              to="/nft-details#nft-auction-banner"
              className="text-res-ls font-bold "
            >
              R34P{" "}
              {gold ? <span className="text-[#FFB800]">Gold</span> : "Platinum"}{" "}
            </NavHashLink>
            <button
              className=" w-[49px] h-6 rounded-lg bg-bright-green text-main-black font-bold text-[12px] leading-[20px]"
            >
              USDT
            </button>
          </div>
          <div>
            <div className="flex  gap-[2px] pb-[12px]">
            </div>
            <hr className="border-[#8A8AA0]" />
          </div>
        </div>
        <div className="pt-[9px] px-[20px] flex justify-between pb-[13px]">
          <div className="flex items-end gap-[9px]">
            <div className="group">
              <button
                onClick={() => setOpenView(true)}
                className=" w-20 h-8 border rounded-[20px] border-solid border-white font-semibold text-[15px] leading-[18px]"
              >
                {" "}
                View
              </button>
              <ViewModal className="" setOpen={setOpenView}></ViewModal>
            </div>
            <button
              onClick={handleBuy}
              className=" w-20 h-8  rounded-[20px] bg-custom-gradient font-semibold text-[15px] leading-[18px] text-light-black"
            >
              {" "}
              Buy
            </button>
          </div>
          <div className="flex flex-col items-end">
            <h1 className="text-[#8A8AA0] text-[13px] leading-[20px] mb-[2px]">
              Current Bid
            </h1>
            <h3 className="text-res-ls font-bold">4.89 ETH</h3>
          </div>x
        </div>
      </div>
    </>
  );
};

export default TierCard;
